import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { StatCard } from '@/components/ui';
import {
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Receipt as ReceiptIcon,
  AccountBalance as BankIcon,
} from '@mui/icons-material';

export const TransactionSummaryCards: React.FC<any> = ({ stats = {} }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box

      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
        gap: 2,
        mb: 4,
      }}
      className="responsive-grid"
    >
      <StatCard
        title="TOTAL REVENUE"
        subtitle="Total amount"
        value={`₹${stats?.data?.success_transaction_amount ?? '0'}`}
        trend="up"
        icon={<TrendingUpIcon />}
        color="success"
        size="medium"
      />

      <StatCard
        title="FAILED PAYMENTS"
        subtitle="Total failed payements"
        value={stats?.data?.failure_transactions ?? '0'}
        trend="down"
        icon={<TrendingDownIcon />}
        color="error"
        size="medium"
      />

      <StatCard
        title="PENDING PAYMENTS"
        subtitle="Total pending"
        value={stats?.data?.pending_transactions ?? '0'}
        trend="neutral"
        icon={<BankIcon />}
        color="warning"
        size="medium"
      />

      <StatCard
        title="TOTAL PAYMENTS"
        subtitle="All payments"
        value={stats?.data?.total_transactions ?? '0'}
        trend="up"
        icon={<ReceiptIcon />}
        color="primary"
        size="medium"
      />
    </Box>
  );
};

export default TransactionSummaryCards;
